import React from 'react';
import { Icon } from 'office-ui-fabric-react';

import { Styled } from './Video.styles';
import { TabProps } from './Video.types';

export const Tab: React.FC<TabProps> = ({ icon, active, onSelect }) => {
  return (
    <Styled.Tab active={active} onClick={onSelect}>
      <Icon iconName={icon} />
    </Styled.Tab>
  );
};
